import {
  getPageResumeQuery,
  getPagePreviewResumeQuery,
} from '@redlink/services';

export const freshCache =
  ({ isEditMode, id, pageName }) =>
  (cache, { data }) => {
    freshResume({ cache, data, isEditMode, id });
    freshPreviewResume({ cache, data, isEditMode, id, pageName });
  };

const freshResume = ({ cache, data, isEditMode, id }) => {
  const freshData = !isEditMode ? data.NewResumeSkill : data.EditResumeSkill;

  let {
    Resume: { skills: oldData, ...rest },
  } = cache.readQuery({
    query: getPageResumeQuery,
  });

  cache.writeQuery({
    query: getPageResumeQuery,
    data: {
      Resume: {
        ...rest,
        skills: getFreshItems({ isEditMode, id, oldData, freshData }),
      },
    },
  });
};

const freshPreviewResume = ({ cache, data, isEditMode, id, pageName }) => {
  const freshData = !isEditMode ? data.NewResumeSkill : data.EditResumeSkill;

  try {
    let {
      ResumePreview: { skills: oldData, ...rest },
    } = cache.readQuery({
      query: getPagePreviewResumeQuery,
      variables: { pageName },
    });

    cache.writeQuery({
      query: getPagePreviewResumeQuery,
      data: {
        ResumePreview: {
          ...rest,
          skills: getFreshItems({
            isEditMode,
            id,
            oldData,
            freshData,
          }),
        },
      },
      variables: { pageName },
    });
  } catch (e) {}
};

const getFreshItems = ({ isEditMode, id, oldData, freshData }) => {
  if (isEditMode) {
    const editedItemIndex = oldData.findIndex((p) => p.id === id);
    oldData = [
      ...oldData.slice(0, editedItemIndex),
      freshData,
      ...oldData.slice(editedItemIndex + 1),
    ];
  } else {
    oldData = [...oldData, freshData];
  }

  return oldData;
};
